
export enum AssetSeatUpholstery {
  Plastic= 'Plastic',
  Fabric= 'Fabric',
  Leather= 'Leather',
  FabricLeather= 'FabricLeather',

}